import React from 'react';
import ReactDOM from 'react-dom';
import './common/styles/index.scss';
import AttachedTicketNetBillingController from './routes/attached-ticket-netbilling/components/AttachedTicketNetBilingController';
import TableCurrentStatus from './routes/cge/components/TableCurrentStatus';
import ServiceStatus from './routes/cge/components/ServiceStatus';
import TablePaid from './routes/cge/components/TablePaid';
import ControllerNoLight from './routes/estas-sin-luz/components/ControllerNoLight';
import ControllerPaymentAgreement from './routes/convenio-de-pagos/components/ControllerPaymentAgreement';
import ApplicationContextProvider from './common/context/ApplicationPropertiesProvider';
import AccessTokenProvider from './common/context/AccessTokenProvider';
import { ClayIconSpriteContext } from '@clayui/icon';
import DebtCurrentOverdue from './routes/debt-current-overdue/components/DebtCurrentOverdue'
import { decode_utf8, getPathName } from './common/utils/utilsFunc';
import BusquedaPrincipal from './routes/busqueda-cliente/components/BusquedaPrincipal';
import ControllerCompensation from './routes/cartola-compensacion-y-reliquidacion/components/ControllerCartolaPublicAndPriv';
import IngressoReclamoController from './routes/IngressoReclamoAndSolicitud/IngressoReclamoController';
import IngressoReclamoPublic from './routes/IngressoReclamoAndSolicitud/IngressoReclamoPublic'
import CgeStyleGuide from "./common/components/CgeStyleGuide";
import { CGE } from './common/components/CGE';
import ConsultStateRequest from './routes/consult-state-request/components/ConsultStateRequest';
import ConsultStateClaim from './routes/consult-state-claim/components/ConsultStateClaim';
import DetailTicketPublic from './routes/attached-ticket-netbilling/components/DetailTicketPublic';
import IngressoSolicitud from './routes/IngressoReclamoAndSolicitud/IngressoSolicitud';
import DebtAndEndowmentPriv from './routes/debtAndEndowment/components/DebtAndEndowmentPriv';
import DebtAndEndowmentControllerPub from './routes/debtAndEndowment/components/DebtAndEndowmentPubController';
import UpdateContactInformation from './routes/update-contact-information/components/UpdateContactInformation';
import ResponseLetter from './routes/response-letter/components/ResponseLetter';
import ListSubscriptions from './routes/subscriptions/components/ListSubscriptions';
import AltaSubscriptions from './routes/subscriptions/components/AltaSubscriptions';
import ModificationSubscriptions from './routes/subscriptions/components/ModificationSubscriptions'
import AnulationSubscription from './routes/subscriptions/components/AnulationSubscriptions'
import ControllerSubscriptionsPub from './routes/subscriptions/components/ControllerSubscriptionsPub';
import ControllerPaymentOnline from './routes/payment-online/components/ControllerPaymentOnline';
import EnergyReconversion from './routes/energy-reconversion/components/EnergyReconversion';
import FormVoluntaryCollectiveProcedure from './routes/form-voluntary-collective-procedure/components/FormVoluntaryCollectiveProcedure'
import FormsElectrodependentController from './routes/electrodependent/components/FormsEctrodependentController';
import GlobalAlert from "./common/components/GlobalAlert";
import getGlobalAlert from "./common/utils/globalAlertFunction"
import AltaSubscriptionsConfirmation from './routes/subscriptions/components/AltaSubscriptionsConfirmation';
import ReadingYourMeter from './routes/AporteDeLectura/components/ReadingYourMeter';
import ProofPayment from './routes/payment-online/components/ProofPayment';
import ConsultSubsidy from './routes/consult-subsidy/components/ConsultSubsidy';
import FormCollectiveGroupingAgreement from './routes/form-collective-grouping-agreement/components/FormCollectiveGroupingAgreement'
import VulnerableAgreementFormController from './routes/vulnerable-agreement-form/components/VulnerebleAgreementFormController'
import ControllerPersonalData from './routes/PersonalData/components/ControllerPersonalData'
import ChangePassword from './routes/changePassword/components/ChangePasswordController';
import ReportController from './routes/stock-report/components/ReportController'
import TablesReportsController from './routes/reports';
import ControllerUserRegister from './routes/user-register/components/ControllerUserRegister'
import NumberAssociatedCustomers from './routes/number-associated-customers/components/NumberAssociatedCustomers'
import AssociatedClientsController from './routes/associated-clients-table/components/AssociatedClientsController';
import DeactiveAccount from "./routes/deactive-account/components/DeactiveAccount"
import RecoverPasswordController from "./routes/recover-password/components/RecoverPasswordController"
import Logout from "./routes/logout/components/Logout"
import RemoveCookieIfNotLoggedIn from "./routes/logout/components/RemoveCookieIfNotLoggedIn"
import NormaTecnica from "./routes/reports/norma-tecnica/components/NormaTecnicaController"
import ReconversionEnergetica from "./routes/reports/reconversion-energetica/components/ReconversionEnergeticaController"
import MedidoresAmiList from './routes/medidores-ami/components/MedidoresAmiList';


function getLiferaySpriteMap() {
	try {
		// eslint-disable-next-line no-undef
		return `${Liferay.ThemeDisplay.getPathThemeImages()}/clay/icons.svg`
	} catch (error) {
		return ''
	}
}

const App = ({ properties }) => {

	const arQtdRowPage = [10, 20, 30, 40, 50];

	const [listToast, setListToast] = React.useState([])
	const [listModal, setListModal] = React.useState([])
	
	properties.setGlobalAlert = setGlobalAlert;

	let returnComponent;

	function setGlobalAlert(description, status, typeAlertModal, titleModal) {
		getGlobalAlert(description, status, listToast, setListToast, typeAlertModal, titleModal, setListModal, listModal);
	}

	React.useEffect(() => {
		if (getPathName() !== 'boleta-y-anexo-netbilling') {
			sessionStorage.removeItem('stateBoletaNetbillingPage');
		}
		if (getPathName() !== 'registro-de-usuario') {
			localStorage.removeItem('state');
		}

	}, [getPathName()])

	if (getPathName() === 'styleguide') {

		var panelActions = <>
			<CGE.InlineRow>
				<CGE.InlineCol>
					<CGE.Button type="primary" size="sm" label="Opa" />
				</CGE.InlineCol>
				<CGE.InlineCol>
					<CGE.Button type="primary" size="sm" label="Opa" />
				</CGE.InlineCol>
			</CGE.InlineRow>
		</>
		returnComponent =

			<div class="container">

				<CGE.Panel
					title="Formulário de cadastro"
					topContent={panelActions}
				>
					<CGE.PanelSection title="1. Dados pessoais">
						<CGE.Icon name="arrow" /> Aqui seus dados pessoaissssss
					</CGE.PanelSection>

					<CGE.PanelSection title="2. Dados da empresa">
						Aqui seus dados da empresa
					</CGE.PanelSection>

				</CGE.Panel>

			</div>
			;
	}


	if (getPathName() === 'pagos-realizados') {
		returnComponent =
			<TablePaid title={properties.titulo_pagos_realizados}
				description={properties.descripcione_pagos_realizados}
				qtdRowPage={arQtdRowPage}
				textNoResults={properties.text_no_results}
				textFetchError={properties.text_fetch_error}
				textLoadingBoleta={properties.text_loading_boleta}
				textFetchNoId={properties.text_fetch_no_id}
				setGlobalAlert={setGlobalAlert}

			/>;
	}

	if (getPathName() === 'saldo-actual') {
		returnComponent =
			<TableCurrentStatus
				title={properties.titulo_saldo_actual}
				description={properties.descripcione_saldo_actual}
				qtdRowPage={arQtdRowPage}
				textNoResults={properties.text_no_results}
				textFetchError={properties.text_fetch_error}
				textAlertExcel={properties.text_alert_excel}
				setGlobalAlert={setGlobalAlert}
			/>;
	}

	if (getPathName() === 'estado-del-servicio') {
		returnComponent =
			<ServiceStatus
				title={properties.titulo_service_status}
				description={properties.descripcione_service_status}
				qtdRowPage={arQtdRowPage}
				textNoResults={properties.text_no_results}
				textFetchError={properties.text_fetch_error}
				textAlertExcel={properties.text_alert_excel}
				setGlobalAlert={setGlobalAlert}
			/>;
	}

	if (getPathName() === 'estas-sin-luz') {
		returnComponent =
			<ControllerNoLight props={properties} apiKeyRecaptcha={properties.api_key_recaptcha} />;
	}

	if (getPathName() === 'convenio-de-pago') {
		returnComponent =
			<ControllerPaymentAgreement properties={properties} />;
	}

	if (getPathName() === 'deuda-actual-y-vencida') {
		returnComponent =
			<DebtCurrentOverdue props={properties} />;
	}

	if (getPathName() === 'busqueda-cliente') {
		returnComponent =
			<BusquedaPrincipal setGlobalAlert={setGlobalAlert} />;
	}

	if (getPathName() === 'boleta-y-anexo-netbilling') {
		returnComponent =
			<AttachedTicketNetBillingController props={properties} />;
	}

	if (getPathName() === 'cartola-de-compensacion' || getPathName() === 'cartola-de-reliquidacion-y-compensacion' || getPathName() === 'cartola-de-reliquidacion') {
		returnComponent =
			<ControllerCompensation
				titleCompensation={properties.titulo_compensation}
				titleReliquidation={properties.titulo_reliquidation}
				description={properties.descripcione_compensation}
				descripcioneCompensationPublic={properties.descripcione_compensation_public}
				descripcioneReliquidationPublic={properties.descripcione_reliquidation_public}
				configCartolaCompasationYears={properties.config_compensation_cartola_years}
				textNoResults={properties.text_no_results}
				textFetchError={properties.text_fetch_error}
				textAlertExcel={properties.text_alert_excel}
				textFetchNoId={properties.text_fetch_no_id}
				textAlertFilledField={properties.text_alert_filled_field}
				setGlobalAlert={setGlobalAlert}
			/>;
	}

	if (getPathName() === 'ingreso-de-reclamo') {
		returnComponent =
			<IngressoReclamoController
				props={properties}
				titleReclamo={properties.titulo_reclamo}
				codigo_empresa={properties.codigo_empresa}
				textFetchError={properties.text_fetch_error}
				url={properties.url_ws_empresa}
			/>;
	}

	if (getPathName().includes('ingreso-de-solicitud')) {
		returnComponent =
			<IngressoSolicitud
				props={properties}
				titleReclamo={properties.titulo_reclamo}
				codigo_empresa={properties.codigo_empresa}
				textFetchError={properties.text_fetch_error}
				url={properties.url_ws_empresa}
				tituloSolicitud={properties.titulo_ingreso_solicitud}
				msgVerification={properties.msg_verification_read_ingreso_solicitud}
				msgCost={properties.msg_cost_ingreso_solicitud}
			/>;
	}

	if (getPathName().includes('solicitudes-y-reclamos')) {
		returnComponent =
			<IngressoReclamoPublic
				props={properties}
			/>;
	}

	if (getPathName() === 'style-guide') {
		returnComponent =
			<CgeStyleGuide />;
	}

	if (getPathName() === 'consulta-estado-de-solicitud') {
		returnComponent =
			<ConsultStateRequest props={properties} />;
	}

	if (getPathName() === 'detalle-de-boleta') {
		returnComponent =
			<DetailTicketPublic props={properties} />;
	}

	if (getPathName() === 'consulta-de-estado-de-reclamo') {
		returnComponent =
			<ConsultStateClaim props={properties} />;
	}

	if (getPathName() === 'emision-certificado-de-deuda') {
		returnComponent =
			<DebtAndEndowmentPriv
				props={properties}
				textNoId={properties.text_fetch_no_id}
				textErrorFetch={properties.text_fetch_error}
				title={properties.titulo_emision_certificado_deuda}
				description={properties.descripcione_emision_certificado_deuda}
				typeCertificate="DE"
				canal="ZOV"
			/>;
	}

	if (getPathName() === 'emision-certificado-de-dotacion') {
		returnComponent =
			<DebtAndEndowmentPriv
				props={properties}
				textNoId={properties.text_fetch_no_id}
				textErrorFetch={properties.text_fetch_error}
				title={properties.titulo_emision_certificado_dotacion}
				description={properties.descripcione_emision_certificado_dotacion}
				typeCertificate="DO"
				canal="ZOV"
			/>;
	}

	if (getPathName() === 'emision-certificado-deuda-dotacion') {
		returnComponent =
			<DebtAndEndowmentControllerPub
				props={properties}
				canal="URL"
			/>;
	}

	if (getPathName() === 'para-estar-informados-completa-tus-datos') {
		returnComponent =
			<UpdateContactInformation props={properties} />;
	}

	if (getPathName() === 'sms-carta-respuesta') {
		returnComponent =
			<ResponseLetter props={properties} />;
	}

	if (getPathName() === 'suscripciones') {
		returnComponent =
			<ListSubscriptions
				props={properties}
				qtdRowPage={arQtdRowPage}
			/>;
	}

	if (getPathName().includes('pago-en-linea') || getPathName() === 'detalle-de-cuenta' || getPathName() === 'detalle-de-cuenta-priv'){
		returnComponent =
			<ControllerPaymentOnline props={properties} />;
	}

	if (getPathName().includes('comprobante-de-pago')) { //check this
		returnComponent =
			<ProofPayment props={properties} />;
	}

	if (getPathName() === 'alta-de-suscripcion') {
		returnComponent =
			<AltaSubscriptions props={properties} />;
	}

	if (getPathName().includes('confirmacion-alta-suscripcion') || getPathName().includes('confirmacion-modificacion-suscripcion')) {
		returnComponent =
			<AltaSubscriptionsConfirmation props={properties} />;
	}

	if (getPathName() === 'suscripcion-boleta-electronica') {
		returnComponent =
			<ControllerSubscriptionsPub props={properties} />;
	}

	if (getPathName() === 'modificacion-suscripcion') {
		returnComponent =
			<ModificationSubscriptions props={properties} />;
	}

	if (getPathName() === 'anulacion-de-suscripcion') {
		returnComponent =
			<AnulationSubscription props={properties} />;
	}

	if (getPathName().includes('solicitud-reconversion-energetica')) {
		returnComponent =
			<EnergyReconversion props={properties} />;
	}

	if (getPathName().includes('procedimiento-voluntario-colectivo')) {
		returnComponent =
			<FormVoluntaryCollectiveProcedure props={properties} />;

	}

	if (getPathName().includes('electrodependientes')) {
		returnComponent =
			<FormsElectrodependentController props={properties} />;
	}

	if (getPathName() === 'aporte-de-lectura') {
		returnComponent =
			<ReadingYourMeter props={properties} />;
	}

	if (getPathName() === 'subsidio-y-beneficios-para-deudas-por-consumos-de-energia-en-pandemia') {
		returnComponent =
			<ConsultSubsidy props={properties} />;
	}

	if (getPathName() === 'formulario-de-convenio-agrupaciones-colectivas') {
		returnComponent =
			<FormCollectiveGroupingAgreement props={properties} />;
	}

	if (getPathName() === 'convenio-vulnerable') {
		returnComponent =
			<VulnerableAgreementFormController props={properties} />;
	}

	if (getPathName() === 'mis-datos-personales') {
		returnComponent =
			<ControllerPersonalData props={properties} />;
	}

	if (getPathName() === 'cambio-de-contrasena') {
		returnComponent =
			<ChangePassword props={properties} />;
	}

	if (getPathName().includes('informe-de-acciones')) {
		returnComponent =
			<ReportController props={properties} />;
	}

	if (getPathName().includes('reports')) {
		returnComponent =
			<TablesReportsController 
			props={properties} 
			qtdRowPage={arQtdRowPage} />;
	}

	if (getPathName().includes('registro-de-usuario')) {
		returnComponent =
			<ControllerUserRegister props={properties} />;
	}

	if (getPathName().includes('agregar-cliente-asociado')) {
		returnComponent =
			<NumberAssociatedCustomers props={properties} />;
	}

	if (getPathName().includes('clientes-asociados')) {
		returnComponent =
			<AssociatedClientsController props={{...properties, arQtdRowPage}} />;
	}

	if (getPathName().includes('desactivar-cuenta-internet')) {
		returnComponent =
			<DeactiveAccount props={{...properties}} />;
	}

	if (getPathName().includes('recuperacion-de-contrasena')) {
		returnComponent =
			<RecoverPasswordController props={{...properties}} />;
	}
	if (getPathName().includes('cierre-sesion')) {
		returnComponent =
			<Logout props={{...properties}} />;
	}
	if (getPathName().includes('servicios-en-linea')) {
		returnComponent =
			<RemoveCookieIfNotLoggedIn props={{...properties}} />;
	}

	if (getPathName().includes('reporte-norma-tecnica')) {
		returnComponent = <NormaTecnica props={properties} qtdRowPage={arQtdRowPage} />;
	}

	if (getPathName().includes('reporte-reconversion-energetica')) {
		returnComponent = <ReconversionEnergetica props={properties} qtdRowPage={arQtdRowPage} />;
	}

    if (getPathName() === 'consulta-medidores-inteligentes') {
        returnComponent = <MedidoresAmiList />;
    }

	return (
		<>
			{returnComponent}
			<GlobalAlert
				toastList={listToast}
				modalList={listModal}
				position="top-right"
				autoDelete={true}
				autoDeleteTime={8000}
			/>
		</>
	)

};

class WebComponent extends HTMLElement {
	connectedCallback() {
		const properties = {
			base_url_api: this.getAttribute('base_url_api'),
			payment_url_api: this.getAttribute('payment_url_api'),
			fintoc_payment_enabled: this.getAttribute('fintoc_payment_enabled'),
			fintoc_payment_key: this.getAttribute('fintoc_payment_key'),
			fintoc_payment_text: this.getAttribute('fintoc_payment_text'),
			fintoc_payment_logo: this.getAttribute('fintoc_payment_logo'),
			fintoc_create_session_endpoint: this.getAttribute('fintoc_create_session_endpoint'),
			name_web_content: this.getAttribute('name_web_content'),
			text_no_results: this.getAttribute('text_no_results'),
			titulo_pagos_realizados: this.getAttribute('titulo_pagos_realizados'),
			descripcione_pagos_realizados: this.getAttribute('descripcione_pagos_realizados'),
			titulo_saldo_actual: this.getAttribute('titulo_saldo_actual'),
			descripcione_saldo_actual: this.getAttribute('descripcione_saldo_actual'),
			titulo_service_status: this.getAttribute('titulo_service_status'),
			titulo_reclamo: this.getAttribute('titulo_reclamo'),
			descripcione_service_status: this.getAttribute('descripcione_service_status'),
			titulo_compensation: this.getAttribute('titulo_compensation'),
			titulo_reliquidation: this.getAttribute('titulo_reliquidation'),
			descripcione_compensation: this.getAttribute('descripcione_compensation'),
			descripcione_compensation_public: this.getAttribute('descripcione_compensation_public'),
			descripcione_reliquidation_public: this.getAttribute('descripcione_reliquidation_public'),
			config_compensation_cartola_years: this.getAttribute('config_compensation_cartola_years'),
			rel_12_2014: this.getAttribute('rel_12_2014'),
			text_fetch_error: this.getAttribute('text_fetch_error'),
			text_loading_boleta: this.getAttribute('text_loading_boleta'),
			text_fetch_no_id: this.getAttribute('text_fetch_no_id'),
			text_alert_excel: this.getAttribute('text_alert_excel'),
			text_alert_filled_field: this.getAttribute('text_alert_filled_field'),
			api_key_recaptcha: this.getAttribute('api_key_recaptcha'),
			codigo_empresa: this.getAttribute('codigo_empresa'),
			url_ws_empresa: this.getAttribute('url_ws_empresa'),
			automatic_payment_stamp: this.getAttribute('automatic_payment_stamp'),
			titulo_automatic_payment_stamp: this.getAttribute('titulo_automatic_payment_stamp'),
			titulo_boleta_anexo_netbilling: this.getAttribute('titulo_boleta_anexo_netbilling'),
			qnt_list_boletas: this.getAttribute('qnt_list_boletas'),
			titulo_last_tickets: this.getAttribute('titulo_last_tickets'),
			descripcione_last_tickets: this.getAttribute('descripcione_last_tickets'),
			titulo_last_tickets_public: this.getAttribute('titulo_last_tickets_public'),
			descripcione_last_tickets_public: this.getAttribute('descripcione_last_tickets_public'),
			descripcione_formulario_contingencia: this.getAttribute('descripcione_formulario_contingencia'),
			last_year_tickets_emission: this.getAttribute('last_year_tickets_emission'),
			text_error_last_year_tickets_emission: this.getAttribute('text_error_last_year_tickets_emission'),
			titulo_ingreso_solicitud: this.getAttribute('titulo_ingreso_solicitud'),
			msg_verification_read_ingreso_solicitud: this.getAttribute('msg_verification_read_ingreso_solicitud'),
			msg_cost_ingreso_solicitud: this.getAttribute('msg_cost_ingreso_solicitud'),



			title_pdf_ticket: this.getAttribute('title_pdf_ticket'),
			titulo_grafico_boleta_anexo_netbilling: this.getAttribute('titulo_grafico_boleta_anexo_netbilling'),
			text_alert_boleta_indisponible: this.getAttribute('text_alert_boleta_indisponible'),
			reclamo_edelmag_content_correo: this.getAttribute('reclamo_edelmag_content_correo'),
			estas_sin_luz_content_correo: this.getAttribute('estas_sin_luz_content_correo'),
			msg_documento_obligatorios: this.getAttribute('msg_documento_obligatorios'),
			msg_confirmacion_crear_convenio_1: this.getAttribute('msg_confirmacion_crear_convenio_1'),
			msg_confirmacion_crear_convenio_2: this.getAttribute('msg_confirmacion_crear_convenio_2'),
			erro_documento_tamano: this.getAttribute('erro_documento_tamano'),
			erro_extension_no_compatible: this.getAttribute('erro_extension_no_compatible'),
			documento_extension: this.getAttribute('documento_extension'),
			cupon_de_pago_1: this.getAttribute('cupon_de_pago_1'),
			cupon_de_pago_2: this.getAttribute('cupon_de_pago_2'),
			cupon_de_pago_3: this.getAttribute('cupon_de_pago_3'),
			web_content_payment_agreement: this.getAttribute('web_content_payment_agreement'),
			web_content_details_payment_file: this.getAttribute('web_content_details_payment_file'),
			titulo_superior_detalles_archivo: this.getAttribute('titulo_superior_detalles_archivo'),
			title_page_consulta_de_estado_de_reclamo: this.getAttribute('title_page_consulta_de_estado_de_reclamo'),
			title_page_consulta_de_estado_de_solicitud: this.getAttribute('title_page_consulta_de_estado_de_solicitud'),
			title_page_consulta_de_estado_de_solicitud_ed: this.getAttribute('title_page_consulta_de_estado_de_solicitud_ed'),
			titulo_emision_certificado_deuda: this.getAttribute('titulo_emision_certificado_deuda'),
			titulo_emision_certificado_dotacion: this.getAttribute('titulo_emision_certificado_dotacion'),
			descripcione_emision_certificado_deuda: this.getAttribute('descripcione_emision_certificado_deuda'),
			descripcione_emision_certificado_dotacion: this.getAttribute('descripcione_emision_certificado_dotacion'),
			web_content_title_update_of_contact_information: this.getAttribute('web_content_title_update_of_contact_information'),
			web_content_info_update_of_contact_information: this.getAttribute('web_content_info_update_of_contact_information'),
			web_content_info_update_of_contact_information_no_aux_text: this.getAttribute('web_content_info_update_of_contact_information_no_aux_text'),
			web_content_certificate_deuda: this.getAttribute('web_content_certificate_deuda'),
			web_content_certificate_dotacion: this.getAttribute('web_content_certificate_dotacion'),
			titulo_actualizacion_de_datos_de_contacto: this.getAttribute('titulo_actualizacion_de_datos_de_contacto'),
			title_response_letter_sms: this.getAttribute('title_response_letter_sms'),
			title_subscription: this.getAttribute('title_subscription'),
			title_alta_subscription: this.getAttribute('title_alta_subscription'),
			title_modification_subscription: this.getAttribute('title_modification_subscription'),
			title_anulation_subscription: this.getAttribute('title_anulation_subscription'),
			description_alta_subscription: this.getAttribute('description_alta_subscription'),
			description_modification_anulation_subscription: this.getAttribute('description_modification_anulation_subscription'),
			web_content_alta_subscription: this.getAttribute('web_content_alta_subscription'),
			web_content_anulation_subscription: this.getAttribute('web_content_anulation_subscription'),
			description_modification_pub: this.getAttribute('description_modification_pub'),
			description_anulation_pub: this.getAttribute('description_anulation_pub'),
			web_content_modification_subscription_email: this.getAttribute('web_content_modification_subscription_email'),
			web_content_note_subscription_pub: this.getAttribute('web_content_note_subscription_pub'),
			titulo_detalle_de_cuenta: this.getAttribute('titulo_detalle_de_cuenta'),
			subtitulo_1_detalle_de_cuenta: this.getAttribute('subtitulo_1_detalle_de_cuenta'),
			subtitulo_2_detalle_de_cuenta: this.getAttribute('subtitulo_2_detalle_de_cuenta'),
			subtitulo_3_detalle_de_cuenta: this.getAttribute('subtitulo_3_detalle_de_cuenta'),
			can_enter_the_customer_number: this.getAttribute('can_enter_the_customer_number'),
			msg_cant_enter_the_customer_numer: this.getAttribute('msg_cant_enter_the_customer_numer'),
			titulo_comprobante_de_pago: this.getAttribute('titulo_comprobante_de_pago'),
			subtitulo_1_comprobante_de_pago: this.getAttribute('subtitulo_1_comprobante_de_pago'),
			subtitulo_2_comprobante_de_pago: this.getAttribute('subtitulo_2_comprobante_de_pago'),
			observacion_comprobante_de_pago: this.getAttribute('observacion_comprobante_de_pago'),
			msg_ingrese_email_envie_comprobante: this.getAttribute('msg_ingrese_email_envie_comprobante'),
			web_content_terminos_y_condiciones: this.getAttribute('web_content_terminos_y_condiciones'),
			title_reconversion_energetica: this.getAttribute('title_reconversion_energetica'),
			subtitulo_1_title_reconversion_energetica: this.getAttribute('subtitulo_1_title_reconversion_energetica'),
			subtitulo_2_title_reconversion_energetica: this.getAttribute('subtitulo_2_title_reconversion_energetica'),
			subtitulo_3_title_reconversion_energetica: this.getAttribute('subtitulo_3_title_reconversion_energetica'),
			subtitulo_4_title_reconversion_energetica: this.getAttribute('subtitulo_4_title_reconversion_energetica'),
			title_procedimiento_voluntario_colectivo: this.getAttribute('title_procedimiento_voluntario_colectivo'),
			subtitulo_procedimiento_voluntario_colectivo: this.getAttribute('subtitulo_procedimiento_voluntario_colectivo'),
			title_forms_electrodependent: this.getAttribute('title_forms_electrodependent'),
			description_forms_electrodependent: this.getAttribute('description_forms_electrodependent'),
			description_forms_electrodependent_seguimiento: this.getAttribute('description_forms_electrodependent_seguimiento'),
			web_content_terms_electrodependent: this.getAttribute('web_content_terms_electrodependent'),
			description_forms_eleccion_medio_informarse: this.getAttribute('description_forms_eleccion_medio_informarse'),
			description_forms_tipos_documentacion: this.getAttribute('description_forms_tipos_documentacion'),
			description_forms_data_certificate_doctor: this.getAttribute('description_forms_data_certificate_doctor'),
			correo_content_name_confirmacion_alta_subscription: this.getAttribute('correo_content_name_confirmacion_alta_subscription'),
			correo_content_name_alta_subscription: this.getAttribute('correo_content_name_alta_subscription'),
			pagination_confirmation_alta_subscription: this.getAttribute('pagination_confirmation_alta_subscription'),
			title_confirmation_alta_subscription: this.getAttribute('title_confirmation_alta_subscription'),
			title_confirmation_modificacion_subscription: this.getAttribute('title_confirmation_modificacion_subscription'),
			pagination_confirmation_modificacion_subscription: this.getAttribute('pagination_confirmation_modificacion_subscription'),
			correo_content_name_modificacion_subscription: this.getAttribute('correo_content_name_modificacion_subscription'),
			tamano_maximo_de_archivo_MB: this.getAttribute('tamano_maximo_de_archivo_MB'),
			tipo_de_archivo: this.getAttribute('tipo_de_archivo'),
			web_content_return_fetch_electrodependent: this.getAttribute('web_content_return_fetch_electrodependent'),
			liferay_base_url: this.getAttribute('liferay_base_url'),
			web_content_meter_reading_contribution_reading: this.getAttribute('web_content_meter_reading_contribution_reading'),
			web_content_terms_conditions_contribution_reading: this.getAttribute('web_content_terms_conditions_contribution_reading'),
			title_contribution_reading: this.getAttribute('title_contribution_reading'),
			content_name_contribution_reading: this.getAttribute('content_name_contribution_reading'),
			subtitle1_contribution_reading: this.getAttribute('subtitle1_contribution_reading'),
			subtitle2_contribution_reading: this.getAttribute('subtitle2_contribution_reading'),
			subtitle3_contribution_reading: this.getAttribute('subtitle3_contribution_reading'),
			subtitle4_contribution_reading: this.getAttribute('subtitle4_contribution_reading'),
			subtitle5_contribution_reading: this.getAttribute('subtitle5_contribution_reading'),
			title_consult_subsidy: this.getAttribute('title_consult_subsidy'),
			subtitle1_consult_subsidy: this.getAttribute('subtitle1_consult_subsidy'),
			subtitle2_consult_subsidy: this.getAttribute('subtitle2_consult_subsidy'),
			title_card1_consult_subsidy: this.getAttribute('title_card1_consult_subsidy'),
			title_card2_consult_subsidy: this.getAttribute('title_card2_consult_subsidy'),
			web_content_return_success_subsidy: this.getAttribute('web_content_return_success_subsidy'),
			web_content_return_fail_subsidy: this.getAttribute('web_content_return_fail_subsidy'),
			title_form_collective_grouping_agreement: this.getAttribute('title_form_collective_grouping_agreement'),
			subtitle1_form_collective_grouping_agreement: this.getAttribute('subtitle1_form_collective_grouping_agreement'),
			subtitle2_form_collective_grouping_agreement: this.getAttribute('subtitle2_form_collective_grouping_agreement'),
			subtitle3_form_collective_grouping_agreement: this.getAttribute('subtitle3_form_collective_grouping_agreement'),
			type_interactions_form_collective_grouping_agreement: this.getAttribute('type_interactions_form_collective_grouping_agreement'),
			web_content_name_form_collective_grouping_agreement: this.getAttribute('web_content_name_form_collective_grouping_agreement'),			
			web_content_terms_form_collective_grouping_agreement: this.getAttribute('web_content_terms_form_collective_grouping_agreement'),			
			title_convenio_vulnerable: this.getAttribute('title_convenio_vulnerable'),
			subtitle_convenio_vulnerable: this.getAttribute('subtitle_convenio_vulnerable'),
			title_section_client: this.getAttribute('title_section_client'),
			title_section_solicitante_convenio_vulnerable: this.getAttribute('title_section_solicitante_convenio_vulnerable'),
			title_section_vulnerabilidad_convenio_vulnerable: this.getAttribute('title_section_vulnerabilidad_convenio_vulnerable'),
			web_content_terms_conditions_convenio_vulnerable: this.getAttribute('web_content_terms_conditions_convenio_vulnerable'),
			title_section_terminos_convenio_vulnerable: this.getAttribute('title_section_terminos_convenio_vulnerable'),
			title_datos_personales: this.getAttribute('title_datos_personales'),
			title_section_datos_personales_1: this.getAttribute('title_section_datos_personales_1'),
			title_section_datos_personales_2: this.getAttribute('title_section_datos_personales_2'),
			title_section_datos_personales_3: this.getAttribute('title_section_datos_personales_3'),
			title_cambio_contrasena: this.getAttribute('title_cambio_contrasena'),
			title_section_cambio_contrasena_1: this.getAttribute('title_section_cambio_contrasena_1'),
			title_section_cambio_contrasena_2: this.getAttribute('title_section_cambio_contrasena_2'),
			condition_cambio_contrasena_1: this.getAttribute('condition_cambio_contrasena_1'),
			condition_cambio_contrasena_2: this.getAttribute('condition_cambio_contrasena_2'),
			condition_cambio_contrasena_3: this.getAttribute('condition_cambio_contrasena_3'),
			condition_cambio_contrasena_4: this.getAttribute('condition_cambio_contrasena_4'),
			select_no_content_name_vulnereble_agreement: this.getAttribute('select_no_content_name_vulnereble_agreement'),
			title_tab_1_vulnereble_agreement: this.getAttribute('title_tab_1_vulnereble_agreement'),
			title_tab_2_vulnereble_agreement: this.getAttribute('title_tab_2_vulnereble_agreement'),
			title_tab_3_vulnereble_agreement: this.getAttribute('title_tab_3_vulnereble_agreement'),
			info_input_file_vulnereble_agreement: this.getAttribute('info_input_file_vulnereble_agreement'),
			title_2_vulnereble_agreement: this.getAttribute('title_2_vulnereble_agreement'),
			title_3_vulnereble_agreement: this.getAttribute('title_3_vulnereble_agreement'),
			tag_vulnereble_agreement: this.getAttribute('tag_vulnereble_agreement'),
			msg_success_vulnereble_agreement: this.getAttribute('msg_success_vulnereble_agreement'),
			title_page_stock_report: this.getAttribute('title_page_stock_report'),
			subtitle_filter_page_stock_report: this.getAttribute('subtitle_filter_page_stock_report'),
			subtitle_chart_page_stock_report: this.getAttribute('subtitle_chart_page_stock_report'),
			title_chart_day_page_stock_report: this.getAttribute('title_chart_day_page_stock_report'),
			title_chart_month_page_stock_report: this.getAttribute('title_chart_month_page_stock_report'),
			title_chart_hour_page_stock_report: this.getAttribute('title_chart_hour_page_stock_report'),
			name_company_1_page_stock_report: this.getAttribute('name_company_1_page_stock_report'),
			name_company_2_page_stock_report: this.getAttribute('name_company_2_page_stock_report'),
			subtitle_y_chart_page_stock_report: this.getAttribute('subtitle_y_chart_page_stock_report'),
			number_years_select_page_stock_report: this.getAttribute('number_years_select_page_stock_report'),
			cantidad_cuotas_mensuales: this.getAttribute('cantidad_cuotas_mensuales'),
			title_detalle_interacciones_report: this.getAttribute('title_detalle_interacciones_report'),
			description_detalle_interacciones_report: this.getAttribute('description_detalle_interacciones_report'),
			section_1_tables_reports: this.getAttribute('section_1_tables_reports'),
			section_2_tables_reports: this.getAttribute('section_2_tables_reports'),
			canal_calcula_tu_cuota: this.getAttribute('canal_calcula_tu_cuota'),
			title_first_page_user_register: this.getAttribute('title_first_page_user_register'),
			subtitle1_first_page_user_register: this.getAttribute('subtitle1_first_page_user_register'),
			subtitle2_first_page_user_register: this.getAttribute('subtitle2_first_page_user_register'),
			text_info_first_page_user_register: this.getAttribute('text_info_first_page_user_register'),
			title_second_page_user_register: this.getAttribute('title_second_page_user_register'),
			description_second_page_user_register: this.getAttribute('description_second_page_user_register'),
			subtitle1_second_page_user_register: this.getAttribute('subtitle1_second_page_user_register'),
			subtitle2_second_page_user_register: this.getAttribute('subtitle2_second_page_user_register'),
			subtitle3_second_page_user_register: this.getAttribute('subtitle3_second_page_user_register'),
			webcontent_info_page_user_register: this.getAttribute('webcontent_info_page_user_register'),
			webcontent_terms_page_user_register: this.getAttribute('webcontent_terms_page_user_register'),
			webcontent_auth_page_user_register: this.getAttribute('webcontent_auth_page_user_register'),
			msg_success_page_user_register: this.getAttribute('msg_success_page_user_register'),
			servicio_description_comprobante_de_pago: this.getAttribute('servicio_description_comprobante_de_pago'),
			titlle_correo_webContent_comprobante_de_pago: this.getAttribute('titlle_correo_webContent_comprobante_de_pago'),
			error_comprobante_de_pago: this.getAttribute('error_comprobante_de_pago'),
			title_page_number_associated_customers: this.getAttribute('title_page_number_associated_customers'),
			description_page_number_associated_customers: this.getAttribute('description_page_number_associated_customers'),
			subtitle_page_number_associated_customers: this.getAttribute('subtitle_page_number_associated_customers'),
			info_send_email_page_number_associated_customers: this.getAttribute('info_send_email_page_number_associated_customers'),
			webcontent_info_page_number_associated_customers: this.getAttribute('webcontent_info_page_number_associated_customers'),
			webcontent_read_more_page_number_associated_customers: this.getAttribute('webcontent_read_more_page_number_associated_customers'),
			webcontent_terms_page_vulnereble_agreement: this.getAttribute('webcontent_terms_page_vulnereble_agreement'),
			title_page_unconfirmed_subscription: this.getAttribute('title_page_unconfirmed_subscription'),
			description_page_associated_customers: this.getAttribute('description_page_associated_customers'),
			title_page_oficina_virtual: this.getAttribute('title_page_oficina_virtual'),
			title_deactive_account: this.getAttribute('title_deactive_account'),
			info_text_deactive_account: this.getAttribute('info_text_deactive_account'),
			title_get_password: this.getAttribute('title_get_password'),
			title_get_password2: this.getAttribute('title_get_password2'),
			description_get_password: this.getAttribute('description_get_password'),
			description_get_password2: this.getAttribute('description_get_password2'),
			email_confirmation_text_get_password: this.getAttribute('email_confirmation_text_get_password'),
			list_DDD_cellphone: this.getAttribute('list_DDD_cellphone'),
			title_norma_tecnica: this.getAttribute('title_norma_tecnica'),
            ami_page_title: this.getAttribute('ami_page_title'),
            ami_column_serial: this.getAttribute('ami_column_serial'),
            ami_column_address: this.getAttribute('ami_column_address'),
            ami_column_valid_from: this.getAttribute('ami_column_valid_from'),
            ami_column_valid_to: this.getAttribute('ami_column_valid_to'),
            ami_loading_meters: this.getAttribute('ami_loading_meters'),
            ami_error_meters: this.getAttribute('ami_error_meters'),
            ami_no_meters: this.getAttribute('ami_no_meters'),
            ami_detail_title: this.getAttribute('ami_detail_title'),
            ami_detail_back_button: this.getAttribute('ami_detail_back_button'),
            ami_detail_loading: this.getAttribute('ami_detail_loading'),
            ami_detail_error: this.getAttribute('ami_detail_error'),
            ami_detail_date_range_title: this.getAttribute('ami_detail_date_range_title'),
            ami_detail_date_range_help: this.getAttribute('ami_detail_date_range_help'),
            ami_detail_date_from_label: this.getAttribute('ami_detail_date_from_label'),
            ami_detail_date_to_label: this.getAttribute('ami_detail_date_to_label'),
            ami_detail_slider_left_label: this.getAttribute('ami_detail_slider_left_label'),
            ami_detail_slider_right_label: this.getAttribute('ami_detail_slider_right_label'),
            ami_detail_days_selected_singular: this.getAttribute('ami_detail_days_selected_singular'),
            ami_detail_days_selected_plural: this.getAttribute('ami_detail_days_selected_plural'),
            ami_detail_chart_title: this.getAttribute('ami_detail_chart_title'),
            ami_detail_chart_hint_prefix: this.getAttribute('ami_detail_chart_hint_prefix'),
            ami_detail_chart_hint_suffix: this.getAttribute('ami_detail_chart_hint_suffix'),
            ami_detail_tabs_total: this.getAttribute('ami_detail_tabs_total'),
            ami_detail_tab_1_key: this.getAttribute('ami_detail_tab_1_key'),
            ami_detail_tab_1_label: this.getAttribute('ami_detail_tab_1_label'),
            ami_detail_tab_1_metric: this.getAttribute('ami_detail_tab_1_metric'),
            ami_detail_tab_1_tooltip: this.getAttribute('ami_detail_tab_1_tooltip'),
            ami_detail_tab_1_cimcodes: this.getAttribute('ami_detail_tab_1_cimcodes'),
            ami_detail_tab_1_labels: this.getAttribute('ami_detail_tab_1_labels'),
            ami_detail_tab_1_y_min: this.getAttribute('ami_detail_tab_1_y_min'),
            ami_detail_tab_1_y_max: this.getAttribute('ami_detail_tab_1_y_max'),
            ami_detail_tab_1_y_unit_label: this.getAttribute('ami_detail_tab_1_y_unit_label'),
            ami_detail_tab_2_key: this.getAttribute('ami_detail_tab_2_key'),
            ami_detail_tab_2_label: this.getAttribute('ami_detail_tab_2_label'),
            ami_detail_tab_2_metric: this.getAttribute('ami_detail_tab_2_metric'),
            ami_detail_tab_2_tooltip: this.getAttribute('ami_detail_tab_2_tooltip'),
            ami_detail_tab_2_cimcodes: this.getAttribute('ami_detail_tab_2_cimcodes'),
            ami_detail_tab_2_labels: this.getAttribute('ami_detail_tab_2_labels'),
            ami_detail_tab_2_y_min: this.getAttribute('ami_detail_tab_2_y_min'),
            ami_detail_tab_2_y_max: this.getAttribute('ami_detail_tab_2_y_max'),
            ami_detail_tab_2_y_unit_label: this.getAttribute('ami_detail_tab_2_y_unit_label'),
            ami_detail_tab_3_key: this.getAttribute('ami_detail_tab_3_key'),
            ami_detail_tab_3_label: this.getAttribute('ami_detail_tab_3_label'),
            ami_detail_tab_3_metric: this.getAttribute('ami_detail_tab_3_metric'),
            ami_detail_tab_3_tooltip: this.getAttribute('ami_detail_tab_3_tooltip'),
            ami_detail_tab_3_cimcodes: this.getAttribute('ami_detail_tab_3_cimcodes'),
            ami_detail_tab_3_labels: this.getAttribute('ami_detail_tab_3_labels'),
            ami_detail_tab_3_y_min: this.getAttribute('ami_detail_tab_3_y_min'),
            ami_detail_tab_3_y_max: this.getAttribute('ami_detail_tab_3_y_max'),
            ami_detail_tab_3_y_unit_label: this.getAttribute('ami_detail_tab_3_y_unit_label'),
            ami_detail_tab_4_key: this.getAttribute('ami_detail_tab_4_key'),
            ami_detail_tab_4_label: this.getAttribute('ami_detail_tab_4_label'),
            ami_detail_tab_4_metric: this.getAttribute('ami_detail_tab_4_metric'),
            ami_detail_tab_4_tooltip: this.getAttribute('ami_detail_tab_4_tooltip'),
            ami_detail_tab_4_cimcodes: this.getAttribute('ami_detail_tab_4_cimcodes'),
            ami_detail_tab_4_labels: this.getAttribute('ami_detail_tab_4_labels'),
            ami_detail_tab_4_y_min: this.getAttribute('ami_detail_tab_4_y_min'),
            ami_detail_tab_4_y_max: this.getAttribute('ami_detail_tab_4_y_max'),
            ami_detail_tab_4_y_unit_label: this.getAttribute('ami_detail_tab_4_y_unit_label'),
            ami_detail_tab_5_key: this.getAttribute('ami_detail_tab_5_key'),
            ami_detail_tab_5_label: this.getAttribute('ami_detail_tab_5_label'),
            ami_detail_tab_5_metric: this.getAttribute('ami_detail_tab_5_metric'),
            ami_detail_tab_5_tooltip: this.getAttribute('ami_detail_tab_5_tooltip'),
            ami_detail_tab_5_cimcodes: this.getAttribute('ami_detail_tab_5_cimcodes'),
            ami_detail_tab_5_labels: this.getAttribute('ami_detail_tab_5_labels'),
            ami_detail_tab_5_y_min: this.getAttribute('ami_detail_tab_5_y_min'),
            ami_detail_tab_5_y_max: this.getAttribute('ami_detail_tab_5_y_max'),
            ami_detail_tab_5_y_unit_label: this.getAttribute('ami_detail_tab_5_y_unit_label'),
            ami_detail_tab_6_key: this.getAttribute('ami_detail_tab_6_key'),
            ami_detail_tab_6_label: this.getAttribute('ami_detail_tab_6_label'),
            ami_detail_tab_6_metric: this.getAttribute('ami_detail_tab_6_metric'),
            ami_detail_tab_6_tooltip: this.getAttribute('ami_detail_tab_6_tooltip'),
            ami_detail_tab_6_cimcodes: this.getAttribute('ami_detail_tab_6_cimcodes'),
            ami_detail_tab_6_y_unit_label: this.getAttribute('ami_detail_tab_6_y_unit_label'),
            ami_detail_date_range_instruction: this.getAttribute('ami_detail_date_range_instruction'),
            ami_detail_no_data_message: this.getAttribute('ami_detail_no_data_message')
        };

		ReactDOM.render(
			<ClayIconSpriteContext.Provider value={getLiferaySpriteMap()}>
				<ApplicationContextProvider properties={properties}>
					<AccessTokenProvider>
						<App properties={properties} />
					</AccessTokenProvider>
				</ApplicationContextProvider>
			</ClayIconSpriteContext.Provider>
			,
			this
		);
	}
}

const ELEMENT_ID = 'remote-app';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}